export const messages = {
	de: {
        // Additional public information; existing locale entries remain unchanged.
        seoContent: {
            "eigenewege": {
                "section1": {
                    "title": "Psychotherapie nach dem Heilpraktikergesetz in Kassel",
                    "paragraph1": "Wenn seelische Belastungen Deinen Alltag erschweren, kann ein persönliches Gespräch helfen, Dein Anliegen zunächst zu sortieren. In meiner Praxis in Kassel begleite ich Dich als Heilpraktiker für Psychotherapie. Gemeinsam schauen wir auf Deine aktuelle Situation, Deine Fragen und darauf, welche Unterstützung zu Dir passt und Du brauchst.",
                    "paragraph2": "Meine Tätigkeit erfolgt auf Grundlage einer auf das Gebiet der Psychotherapie beschränkten Heilpraktikererlaubnis. Ob eine psychotherapeutische Begleitung in meiner Praxis infrage kommt, hängt von Deinem Anliegen, dem Behandlungsbedarf und meiner fachlichen Kompetenz ab. Die Nennung eines Beschwerdebildes auf dieser Website ist deshalb keine pauschale Zusage, jede Ausprägung behandeln zu können."
                },
                "section2": {
                    "title": "Ein erster Kontakt, ein gemeinsamer Überblick",
                    "paragraph1": "In einer unverbindlichen telefonischen Erstberatung klären wir, was Dich beschäftigt und welche Fragen Du vor einem möglichen persönlichen Kennenlern-Termin hast. In einem anschließenden Kennenlern-Gespräch nehmen wir uns Zeit für Deine Belastungen, bisherige Unterstützung und Deine Erwartungen. Auch Ablauf, Honorar und die nächsten Schritte besprechen wir miteinander.",
                    "paragraph2": "Körperliche Beschwerden sollten bei Bedarf ärztlich abgeklärt werden. Wenn Dein Anliegen eine andere oder weitergehende Versorgung erfordert, etwa eine fachärztliche, spezialisierte psychotherapeutische oder stationäre Behandlung, erörtern wir das offen in unserem Gespräch. Mein Angebot ersetzt keine medizinische Notfallversorgung."
                }
            },
            "staunendlernen": {
                "section1": {
                    "title": "Coaching und persönliche Orientierung in Kassel",
                    "paragraph1": "Nicht jede schwierige Lebensphase ist eine psychische Erkrankung. Manchmal geht es um eine Entscheidung, einen beruflichen Übergang oder die Frage, wie Du Deinen Alltag stärker nach Deinen eigenen Werten gestalten möchtest. Im Coaching können wir solche Anliegen gemeinsam betrachten und konkrete Ziele für Deine persönliche Entwicklung formulieren.",
                    "paragraph2": "Dabei stehen Deine Erfahrungen, Stärken und Handlungsmöglichkeiten im Mittelpunkt. Coaching ist hier ein Angebot zur persönlichen Orientierung und Entwicklung. Es dient nicht dazu, eine behandlungsbedürftige psychische Erkrankung zu diagnostizieren oder zu therapieren."
                },
                "section2": {
                    "title": "Was Du von einem Coaching-Gespräch erwarten kannst",
                    "paragraph1": "Zu Beginn klären wir, was Du verändern möchtest und welche Resultate Dir wirklich weiterhelfen würden. Wir betrachten wiederkehrende Muster, nehmen unterschiedliche Perspektiven ein und besprechen mögliche nächste Schritte für Deinen Alltag. Du entscheidest, welche Themen Raum bekommen und welche Lösungen für Dich stimmig sind.",
                    "paragraph2": "Wenn im Gespräch deutlich werden sollte, dass eine psychische Erkrankung vorliegt, braucht es eine entsprechende fachliche Abklärung. Dann unterscheiden wir sorgfältig zwischen Coaching und einer möglichen psychotherapeutischen Behandlung. Ein Coaching ersetzt weder eine notwendige Psychotherapie noch eine ärztliche Behandlung."
                }
            },
            "breathwork": {
                "section1": {
                    "title": "Breathwork und bewusstes Atmen in Kassel",
                    "paragraph1": "Breathwork ist ein Sammelbegriff für unterschiedliche Formen bewusster Atemarbeit. Ruhige Atemwahrnehmung und intensive dynamische Atemmethoden unterscheiden sich im Ablauf und den Anforderungen. Deshalb lohnt es sich, vor einer Teilnahme genau zu klären, welche spezielle Form angeboten wird und was Dich dabei erwartet.",
                    "paragraph2": "In meinem Angebot geht es um angeleitete Selbsterfahrung: Du nimmst Dir Zeit, Deinen Atem, körperliche Empfindungen und Dein eigenes Erleben bewusster wahrzunehmen. Es gibt dabei kein bestimmtes Gefühl, dass Du erreichen musst, und keine Erfahrung, die bei allen Menschen gleich ausfällt."
                },
                "section2": {
                    "title": "Welche Atempraxis passt zu Deiner Situation?",
                    "paragraph1": "Vor einer Teilnahme sind Fragen zu Deiner aktuellen körperlichen und seelischen Verfassung und möglichen gesundheitlichen Einschränkungen wichtig. Nicht jede Atemmethode passt zu jedem Menschen. Insbesondere bei intensiveren Techniken sollten die jeweiligen Teilnahmevoraussetzungen vorab besprochen und gesundheitliche Fragen gegebenenfalls ärztlich geklärt werden.",
                    "paragraph2": "Atemarbeit ist in diesem Angebot keine Behandlung körperlicher oder psychischer Erkrankungen und ersetzt keine notwendige medizinische oder psychotherapeutische Versorgung. Wenn Du Dich für PSYCHEDELIC BREATH® interessierst, findest Du auf der eigenen Angebotsseite zusätzliche Angaben zur Methode und zu den dort genannten Kontraindikationen.",
                    "relatedLabel": "Zum Angebot PSYCHEDELIC BREATH®"
                }
            },
            "freiheitatmen": {
                "section1": {
                    "title": "PSYCHEDELIC BREATH®: Ablauf und persönliche Vorbereitung",
                    "paragraph1": "PSYCHEDELIC BREATH® ist ein bestimmtes Format dynamischer Atemarbeit mit Musik. Es ist von ruhiger Atembeobachtung zu unterscheiden. Auf dieser Seite findest Du Informationen zum Konzept und zu den Teilnahmevoraussetzungen; vor einem Termin ist außerdem Raum für Deine persönlichen Fragen.",
                    "paragraph2": "Wichtig ist, dass Du vorab weißt, welche gesundheitlichen Einschränkungen gegen eine Teilnahme sprechen können. Schau Dir hierzu noch einmal die Kontraindikationen an. Halte gerne mit mir oder Deinem Arzt Rücksprache, solltest Du Dir unsicher sein."
                },
                "section2": {
                    "title": "Teilnahmevoraussetzungen und Grenzen der Atempraxis",
                    "paragraph1": "Bitte beachte die auf dieser Seite aufgeführten Kontraindikationen. Eine dynamische Atempraxis ist nicht für alle Menschen geeignet. Wenn Du gesundheitliche Beschwerden hast, Medikamente einnimmst, die mit den oben genannten Kontraindikationen in Zusammenhang stehen oder Dir unsicher bist, ist vor einer Teilnahme gegebenenfalls eine ärztliche Abklärung erforderlich. Eine Anfrage allein bedeutet noch keine Zusage, dass eine Teilnahme für Dich passend ist.",
                    "paragraph2": "Mein Angebot dient der angeleiteten Selbsterfahrung. Es ist kein Ersatz für eine notwendige ärztliche oder psychotherapeutische Behandlung und beinhaltet kein Versprechen, Erkrankungen zu heilen. Wir können im Vorfeld besprechen, was Du Dir wünschst und welche Fragen vor einer Teilnahme noch offen sind."
                }
            },
           "aboutme": {
    "section1": {
        "title": "Heilpraktiker für Psychotherapie in Kassel: Meine berufliche Rolle",
        "paragraph1": "Ich begleite Menschen als Heilpraktiker für Psychotherapie in meiner Praxis in Kassel. Grundlage dieser Tätigkeit ist die Erlaubnis zur Ausübung der Heilkunde, beschränkt auf das Gebiet der Psychotherapie. Diese Erlaubnis ist von einem Psychologiestudium und einer Approbation als Psychotherapeut zu unterscheiden.",
        "paragraph2": "Für die Zusammenarbeit ist mir wichtig, dass Du weißt, welche Unterstützung ich anbiete und wo ihre Grenzen liegen. Eine Einschätzung und Diagnose psychischer Beschwerden erfolgt innerhalb meiner Erlaubnis und meiner fachlichen Kompetenz. Jenseits dieser Grenzen ist eine weitere ärztliche Abklärung oder eine andere spezialisierte Versorgung erforderlich. In diesem Fall kann ich Dich auf ausdrücklichen Wunsch weiterhin parallel begleiten."
    },
    "section2": {
        "title": "Ausbildung, Arbeitsweise und Beziehung zwischen Therapeut und Patient/Klient",
        "paragraph1": "Mein bisheriger Werdegang und die Ausbildung zum Heilpraktiker für Psychotherapie bilden den Hintergrund meiner Arbeit. Im persönlichen Kennenlernen sprechen wir darüber, welche Gesprächs- und Begleitungsangebote ich für Dein Anliegen einsetze und welche Erfahrungen und Qualifikationen ihnen zugrunde liegen.",
        "paragraph2": "Eine vertrauensvolle Zusammenarbeit braucht neben fachlicher Klarheit auch eine vertrauensvolle Beziehung zwischen Therapeut und Patient/Klient. Du darfst gerne nach meiner Ausbildung, den Grenzen meines Angebots und dem geplanten Vorgehen fragen. Ebenso besprechen wir, ob meine Begleitung für Deine Situation geeignet ist oder ob eine andere Anlaufstelle sinnvoller ist."
    },
    "qualificationDraft": {
        "title": "Qualifikationen und Nachweise",
        "intro": "",
        "item1": "Erlaubnis zur Ausübung der Heilkunde, beschränkt auf das Gebiet der Psychotherapie: erteilt durch die Stadt Kassel am 12. April 2021.",
        "item2": "Ausbildung zum Heilpraktiker für Psychotherapie: Paracelsus – die Heilpraktikerschulen. Lehrgangsdauer: 06.09.2018 bis 31.12.2020.",
        "item3": "Supervision und Qualitätssicherung: seit 2021 kontinuierliche, monatliche tiefenpsychologische Supervision mit Fallanalysen.",
        "item4": "Zertifizierter PSYCHEDELIC BREATH® Teacher seit November 2026."
    }
}
        },

		basics: {
			login: "Einloggen",
			logout: "Ausloggen",
			register: "Registrieren",
			password: "Passwort",
			menu: "Menü",
			hello: "Hallo",
			edit: "{type} bearbeiten",
			new: "{type} anlegen",
			duplicate: "{type} duplizieren",
			lock: "{type} sperren",
			unlock: "{type} entsperren",
			add: "{type} hinzufügen",
			goto: "zu {type} wechseln",
			filter: "{type} filtern",
			missing: "Benötigte {type}",
			delete: "{type} Löschen",
			remove: "{type} Entfernen",
			hide: "{type} ausblenden",
			publish: "{type} veröffentlichen",
			accept: "{type} akzeptieren",
			deny: "{type} ablehnen",
			name: "Name",
			confirm: "Bestätigen",
			startDate: "Startdatum",
			endDate: "Enddatum",
			role: "Rolle",
			type: "Typ",
			email: "E-Mail",
			permissions: "Rollen",
			lastLogin: "Letzter Login",
			save: "Anwenden",
			user: "Benutzer",
			firstName: "Vorname",
			lastName: "Nachname",
			notRegistered: "Registrierung nicht abgeschlossen",
			startTime: "Startzeit",
			endTime: "Endzeit",
			backToLogin: "Zurück zum Login",
			street: "Straße",
			housingNumber: "Hausnummer",
			zipcode: "Postleitzahl",
			city: "Stadt",
			additionalAddress: "Addresszusatz",
			status: "Status",
			phone: "Telefon",
			fax: "Fax",
			created: "Angelegt am",
			lastUpdated: "Zuletzt bearbeitet am",
			zip_code: "PLZ",
			uploadedOn: "Hochgeladen am",
			uploadedBy: "Hochgeladen von",
			changedOn: "Geändert am {datetime}",
			changedBy: "Geändert von",
			gender: "Geschlecht",
			male: "Männlich",
			female: "Weiblich",
			diverse: "Divers",
			date: "Datum",
			time: "Zeit",
			privacy: "Datenschutz",
			imprint: "Impressum",
			go: "Los",
			error: "Fehler",
			count: "Anzahl: {count}",
			yes: "Ja",
			no: "Nein",
			homeAddress: "Wohnort",
			baseData: "Basisdaten",
			systemData: "Systemdaten",
			number: "Nummer",
			premise: "Standort",
			country: "Land",
			address: "Adresse",
			patient: "Patient",
			patients: "Patienten",
			appointment: "Termin",
			appointments: "Termine",
			accounting: "Rechnung",
			accountings: "Rechnungen",
			course: "Kurs",
			courses: "Kurse",
			birthday: "Geburtstag",
			oClock: "Uhr",
			comment: "Kommentar",
			markTemporary: "Temporär",
			color: "Farbe",
			therapist: "Therapeut",
			room: "Raum",
			product: "Produkt",
			description: "Beschreibung",
			price: "Preis",
			duration: "Dauer (in 30min Einheiten)",
			durationSimple: "Dauer",
			minutes: "Minuten",
			paymentMethod: "Bezahlungsmethode",
			activePatient: "Aktiver Patient",
			calendarColorCode: "Farbe im Kalender",
			digitalMedia: "Digitaler Inhalt",
			digitalMedias: "Digitale Inhalte",
			digitalMediaFile: "Datei",
			digitalMediaFiles: "Dateien",
			file: "Datei",
			files: "Dateien",
			expand: "Ausklappen",
			drag: "Verschieben",
			notifications: "Benachrichtigungen",
			all: "Alle",
			therapists: "Therapeuten",
			directions: " Anfahrt über Google Maps",
			subject: "Betreff",
			message: "Nachricht",
			send: "Senden",
			holiday: "Schließzeit / Feiertag",
			ressources: "Ressource",
			calendarWeek: "KW",
			pto: "Abwesenheit",
			customAddress: "Eigene Adresse",
			numPatients: "Anzahl Plätze",
			to: "bis",
			retreat: "Retreat",
			retreats: "Retreats",
			service: "Leistung",
			travelTimePrev: "Anreisezeit",
			travelTimeAfter: "Abreisezeit",
			prepTimePrev: "Vorbereitung",
			prepTimeAfter: "Nachbereitung",
			saved: "Gespeichert",
			info: "Infos",
			dueDate: "Fälligkeitsdatum",
			dueDateShort: "Fällig",
			priceMin: "Preis (min)",
			priceMax: "Preis (max)",
			priceBill: "Preis (Rechnung)",
			categories: "Kategorien",
			participants: "Teilnehmende",
			needsToBeBilled: "Offene Posten",
			notPaid: "Unbezahlte Rechnungen",
			overdue: "Überfällige Rechnungen",
			vatExempt: "Mehrwertsteuerbefreit",
			privateInsurance: "Rechnung für Privatversicherte",
			diagnoses: "Diagnosen",
			billingNumber: "Rechnungsnummer",
			receiver: "Rechnungsempfänger",
			company: "Firma",
			bill: "Rechnung",
			sum: "Summe",
			paidBy: "Rechnung getragen von",
			unit: "Einheit",
			ical: "ICal (Privatadresse)",
			stayAvailable: "Nicht als abwesend markieren",
			goToDashboard: "Zum Dashboard",
			availProducts: "Verfügbare Produkte",
			shoppingCart: "Warenkorb",
			agb: "AGB",
			reload: "Neu laden",
			net: "Netto",
			brut: "Brutto",
			mailSent: "Email wurde versendet!",
			appointmentReminder: "Terminerinnerung",
			billingDate: "Abrechnen bis inklusive",
			optional: "optional",
			soloBill: "Einzelrechnung pro Patient erstellen (für Sammelempfänger)",
			digitalmedia: "Digitaler Inhalt",
			availFileTypes: "Unterstützte Dateiformate",
			fileTypeDocuments: "Dokumente",
			fileTypeImages: "Bilder",
			fileTypeVideos: "Videos",
			fileTypeAudios: "Audio",
			fileTypeArchives: "Archive",
			tags: "Schlagworte",
			groupAppointment: "Gruppenkurs",
			soloAppointment: "Einzeltermin",
			defaultPrice: "Standardpreis",
			defaultDuration: "Standard Dauer",
			defaultduration: "Standarddauer",
			thumbnail: "Vorschaubild",
			productType: "Produkttyp",
			month: "Monat",
			"digitalContents": "Digitale Inhalte",
			"content": "Inhalt",
			"paymentType": "Zahlungsart",
			"price": "Preis",
			"access": "Zugriff",
			"paidUntil": "Bezahlt bis",
			"monthlySubscription": "Monatsabo",
			"oneTimePayment": "Einmalzahlung",
			"month": "Monat",
			"active": "Aktiv",
			"endedOrBlocked": "Beendet / gesperrt",
			"permanent": "Dauerhaft",
			"bookedAppointments": "Gebuchte Termine",
			"appointment": "Termin",
			"date": "Datum",
			"time": "Uhrzeit",
			"payment": "Zahlung",
			"invoice": "Rechnung",
			"followUpAppointment": "Folgetermin",
			"paid": "Bezahlt",
			"pending": "Offen",
			"invoices": "Rechnungen",
			"invoiceNumber": "Rechnungsnummer",
			"created": "Erstellt",
			"due": "Fällig",
			"amount": "Betrag",
			"status": "Status",
			"file": "Datei",
			"open": "Öffnen",
			"overdue": "Überfällig",
			"oneTimePaymentsAndAppointments": "Einmalzahlungen und Termine",
    		"monthlySubscriptions": "Monatsabos",
			cancelSubscription: 'Abo kündigen',
			cancelAppointment: 'Stornieren',
			actions: "Aktionen",
			"back": "Zurück",
			"cancelBooking": "Stornieren",
			"confirmCancellation": "Stornierung bestätigen",
			"cancelled": "Storniert",
			"paid": "Bezahlt",
			"open": "Offen",
			"checkAgain": "Erneut prüfen",
			"notPurchasable": "Nicht kaufbar",
			digitalBundle: "Medienpaket",
			digitalBundles: "Medienpakete",
			otherContents: "Weitere Inhalte",
			"confirmCancellation": "Kündigung bestätigen",
			"cancelAtPeriodEnd": "Zum Laufzeitende kündigen",
			"invoiceDateOrDueDate": "Datum / Fälligkeit",
			"monthlySubscription": "Monatsabo",
			"oneTimePurchase": "Einzelkauf",
			"testInvoice": "Testrechnung",
			"sendInvoiceByEmail": "Rechnung per E-Mail senden",
			"downloadInvoice": "Rechnung herunterladen",
			"openInvoiceInNewTab": "Rechnung in neuem Tab öffnen",
			freeOfCharge: "kostenlos",
			maintenance: "Geplante Wartungsarbeiten",
			maintenanceIntervalSimple: "am {startDate}, von {startTime} bis {endTime} kann es zu Störungen kommen",
			maintenanceIntervalMultiple: "vom {startDate} - {endDate}, von {startTime} bis {endTime} kann es zu Störungen kommen",
		},
		messages: {
			cancelCheckout: 'Checkout abbrechen',
			confirmCancelSubscription: 'Möchtest du das Abo „{name}“ zum Ende des bezahlten Zeitraums kündigen? Der Zugang bleibt bis zum {date} bestehen.',
			"cancelledAtPeriodEnd": "Zum Periodenende gekündigt",
            "reservedInCheckout": "Im Checkout reserviert",
			"buy": "Kaufen",
			"subscribe": "Abo abschließen",
			"noItems": "Keine Einträge vorhanden",
			tooLong: "Eingabe zu lang, max: {count}!",
			required: "Pflichtfeld!",
			fileTooBig: "Datei zu groß, maximal: {size}",
			validSelectionrequired: "Valide Auswahl treffen!",
			loginToAccount: "Mit Account",
			continueWithoutAccount: "Ohne Account",
			forgotPassword: "Passwort vergessen",
			switchTheme: "Farbschema wechseln",
			wrongEMailFormat: "Bitte geben Sie eine gültige E-Mail-Addresse ein.",
			noLoginFound: "Noch nicht eingeloggt",
			noData: "Keine {type} vorhanden",
			noSelection: "Keine {type} ausgewählt",
			chooseOption: "Bitte eine Option auswählen",
			passwordTooShort: "Das eingegebene Passwort ist zu kurz!",
			notSamePassword: "Passwörter stimmen nicht überein!",
			wrongPassword: "E-Mail oder Passwort stimmen nicht!",
			noItems: "Keine Einträge vorhanden",
			acceptPrivacySettings: "Ich stimme der <a href='privacy' target='_blank'>Datenschützerklärung</a> zu",
			registerDoneTitle: "Registrierung fast fertig",
			registerDoneMessage: "Sie haben eine E-Mail erhalten, um den Registrierungsprozess abzuschließen. <br><br> Sehen Sie auch im Spam-Ordner nach.",
			activeCourses: "Aktive Kurse",
			openBilling: "Offene Rechnungen",
			appointmentsToday: "Termine heute",
			appointmentsWeek: "Termine diese Woche",
			latestActivities: "Letzte Aktivitäten",
			welcomeBack: "Willkommen zurück, {name}",
			nextAppointments: "Meine nächsten Termine",
			noStreet: "Keine Straße",
			noCity: "Keine Stadt",
			noProduct: "Kein Produkt",
			noAddress: "Keine Adresse",
			contactCheckboxText: "Ich stimme zu, dass meine Angaben aus dem Kontaktformular zur Beantwortung meiner Anfrage erhoben und verarbeitet werden. Die Daten werden nach abgeschlossener Bearbeitung Ihrer Anfrage gelöscht. Detaillierte Informationen zum Umgang mit Nutzerdaten finden Sie in unserer <a href='privacy' target='_blank'>Datenschützerklärung</a>.",
			contactDoneTitle: "Herzlichen Dank",
			contactDoneMessage: "Ich habe deine Anfrage erhalten und melde mich so bald wie möglich",
			quickActions: "Schnellaktionen",
			roomConflict: "Raumkonflikt",
			teacherUnavailable: "Therapeut nicht verfügbar",
			ressourceUnavailableForThisDay: "Eine Ressource ist für diesen Tag nicht verfügbar",
			appointmentSuggestionPatient: "Bestätigung durch Patienten notwendig (Nur für Einzeltermine möglich). Der Patient erhält eine Mail.",
			appointmentSuggestionPatientInfo: "Terminerinnerungen werden gebündelt 1x pro Stunde versendet.",
			todos: "Todos",
			timeSlotSuggestion: "Terminanfrage",
			retreatSuggestions: "Anmeldung Retreat",
			publicAppointment: "Termindaten öffentlich anzeigen",
			publicAppointmentInfo: "Patientendaten bleiben verborgen, nur möglich für öffentliche Produkttypen",
			holidayOnThisDate: "An diesem Tag ist Feiertag",
			actionCantBeUndone: "Diese Aktion kann nicht rückgängig gemacht werden",
			confirmDeletionItem: "Sind Sie sicher, dass Sie {item} löschen wollen?",
			startDateTooBig: "Startdatum zu groß",
			travelTimeInfoText: "An-/Abreisezeit in Stundeneinheiten (1 = 30min)",
			prepTimeInfoText: "Vor-/Nachbreitungszeit in Stundeneinheiten (1 = 30min)",
			download: "Herunterladen",
			openInNewTab: "In neuem Tab öffnen",
			showFilters: "Filter anzeigen",
			defaultAppointmentProduct: "Standardauswahl für Termine (dieses Produkt ist in der Terminanfrage von Patienten hinterlegt)",
			makeDefaultAppointmentProduct: "Zur Standardauswahl für Termine machen",
			showCancelledAppointments: "Abgelehnte Termine anzeigen",
			hideCancelledAppointments: "Abgelehnte Termine ausblenden",
			generateBillingCycle: "Rechnungslauf generieren",
			generateBillingCycleText: "Alle offenen Posten werden in Rechnungen zusammengefasst. Rechnungsnummern können nicht mehr rückgängig gemacht werden.",
			defaultBillService: "Leistung wird automatisch in Rechnungen eingetragen",
			markedService: "Leistung wird visuell hervorgehoben (nur intern)",
			defaultBillDiagnosis: "Diagnose wird automatisch für Psychotherapie in Rechnungen eingetragen",
			isPsycotherapy: "Psychotherapeutisches Produkt",
			isCompanyAccount: "Firmenaccount",
			appointmentsInThisBill: "Termine in dieser Abrechnung",
			additionalAppointments: "Zusätzliche Termine",
			showStatusChangeHint: "Die Rechnung wird erstellt und kann danach nicht mehr abgeändert werden. Fortfahren?",
			confirmStatusChange: "Ich bestätige und möchte diese Rechnung finalisieren",
			markBillHasBeenPaid: "Die Rechnung als 'bezahlt' markieren",
			billHasBeenPaid: "Rechnung bezahlt",
			sendMaiToReceiver: "Rechnung direkt per Mail zustellen",
			resendBillingMail: "Rechnung per Mail senden",
			resendBillingMailText: "Die Rechnung wird dem Rechnungsempfänger erneut zugestellt",
			followUpFor: "Folgetermin für",
			noUser: "Kein Patient eingetragen",
			followUpFor: "Folgetermin für den Termin vom {date}",
			addFollowUpFor: "Folgetermin eintragen",
			googleImport: "Importiert von Google Calendar",
			buy: "Jetzt kaufen",
			itemAdded: "Item hinzugefügt!",
			availTimeSlots: "Verfügbare Termine (60 min)",
			resendRegistration: "Registrierungsmail erneut versenden?",
			resendRegistrationText: "Ein neuer Link wird per Mail an den Patienten verschickt. Der alte ist damit ungültig. Dieser Link ist nur etwa 2 Tage gültig.",
			thisCanTakeSomeMin: "Das kann ein paar Minuten dauern",
			mailChangeProcedure: "Ablauf der Mailänderung:<br>1. Wir schicken eine Mail an Ihre alte Adresse mit Bitte um Erlaubnis<br>2. Wir schicken eine E-Mail an Ihre neue Adresse<br>3. Sie können sich fortan mit der neuen Mail einloggen <br><br>Keinen Zugang mehr zur alten Adresse? Melden Sie sich bei uns direkt.",
			newBillForPatient: "Neue Rechnung verfügbar",
			requestApppointment: "Terminanfragen stellen",
			bookAppointmentRequest: "Terminanfrage stellen",
			cancelAppointmentRequest: "Terminanfrage absagen",
			requestAppointmentInfoText: "Möchten Sie eine Terminanfrage für {therapist} für den <b>{date}</b> von <b>{startTime}</b> Uhr bis <b>{endTime}</b> Uhr stellen?<br><br>",
			cancelAppointmentInfoText: "Möchten Sie die Terminanfrage für {therapist} für den <b>{date}</b> von <b>{startTime}</b> Uhr bis <b>{endTime}</b> Uhr absagen?<br><br>",
			requestSent: "Anfrage gesendet",
			maxRequestsReached: "Maximale Anfragenanzahl erreicht. Bitte warten Sie auf Bestätigung",
			activePatientExplanation: "Muss aktiv sein, um Termine buchen zu können",
			privateInsuranceExplanation: "Wenn aktiv wird die Rechnungsvorlage für Privatversicherte verwendet. ACHTUNG: Gilt für Rechnungsempfänger",
			soloBillExplanation: "Wenn aktiv, generiert pro Patient 1 Rechnung, z.B wenn der Empfänger eine private Versicherung ist (Dann kombinieren mit 'Rechnung für privatversicherte'!).",
			paidByExplanation: "Optionales Feld: An wen wird die Rechnung versendet. Vorlage für Privatversicherung sowie Einzelrechnung wird über den Empfänger entschieden!",
			appointmentRequest: "gestellte Terminanfragen",
			teacherConflict: "Therapeut besetzt",
			saveAndSendAppointmentChangedMail: "Speichern und Terminänderungsmail schicken",
			regenerate: "Regenerieren",
			psychotherpyServiceMessage: "Für Psychotherapeutische Produkte entspricht der Netto Preis dem Rechnungspreis",
			imageMissing: "Bild fehlt",
			publicAppointmentImage: "Bild für öffentlichen Termin zum Produkt {product}",
			availSlots: "Noch {free} von {total} Plätzen frei",
			shoppingCartWarningNoConnection: "Der Buchungsstatus konnte nicht geprüft werden. Bitte erneut versuchen.",
			shoppingCartWarningAlreadyBought: "Bereits gekaufte oder gebuchte Artikel sind grau markiert und werden nicht erneut gekauft.",
			shoppingCartWarningBundleOverlap: "Folgende Medien sind bereits in einem Bundle im Warenkorb enthalten und würden doppelt berechnet: {names}. Bitte diese Medien aus dem Warenkorb entfernen.",
			"cancelPatientBookingTitle": "Patientenbuchung stornieren?",
			"cancelPatientBookingSeriesInfo": "Der Platz wird freigegeben. Bei einer gemeinsam gebuchten Terminserie werden alle zugehörigen Termine dieses Patienten storniert.",
			"cancelPatientBookingCheckoutInfo": "Ein noch offener Checkout wird vollständig abgebrochen, einschließlich weiterer Artikel und Buchungen darin.",
			"cancelPatientBookingRefundWarning": "Die Stornierung gibt den Platz frei. Eine bereits erfolgte Zahlung wird dadurch nicht zurückerstattet. Falls eine Rückerstattung erfolgen soll, muss diese separat im Stripe-Dashboard veranlasst werden.",
			"unsavedEditorChangesDiscarded": "Nicht gespeicherte Änderungen im Editor werden verworfen.",
			"paidWithoutAutomaticRefund": "Bezahlt; keine automatische Erstattung.",
			"notPaid": "Nicht bezahlt.",
			"bookingCancelledOn": "Storniert am {date}.",
			"bookingCancellationByPhone": "Stornierungen bitte telefonisch beim Therapeuten anfragen.",
			"bookingCancellationNotConfirmed": "Stornierung wurde nicht bestätigt.",
			"purchaseStatusCheckFailed": "Der Kaufstatus konnte nicht geprüft werden. Bitte erneut prüfen.",
			"itemNotPurchasable": "Dieser Artikel ist nicht kaufbar.",
			"invalidPurchaseStatus": "Ungültiger Kaufstatus",
			"incompletePurchaseStatus": "Unvollständiger Kaufstatus",
			"digitalMediaImage": "Bild zum digitalen Inhalt",
			"digitalMediaDuration": "{minutes} min",
			"shopAlreadyOwned": "Dieses digitale Medium hast du bereits gekauft.",
			"shopCheckoutPending": "Für dieses Medium läuft bereits ein Checkout.",
			"shopSubscriptionExists": "Für dieses Medium besteht bereits ein Abo.",
			"shopAlreadyBooked": "Diesen Termin oder einen Folgetermin der Serie hast du bereits gebucht.",
			monthlySubscriptionHint: "Der Preis wird monatlich abgerechnet.",
			invalidPrice: "Bitte einen Preis zwischen 0 und 99.999,99 mit maximal zwei Nachkommastellen eingeben.",
			bundleLoadFailed: "Die Daten konnten nicht vollständig geladen werden. Bitte erneut öffnen.",
			digitalMediaWithId: "Digitales Medium #{id}",
			digitalBundleImage: "Vorschaubild für {name}",
			bundleMediaCount: "Enthaltene Medien: {count}",
			subscriptionText: "Der Preis wird monatlich abgerechnet. Kündigung über die Abo-Verwaltung.",
			manageSubscription: "Abo verwalten",
			invoiceEmailSent: "Eine Mail mit der Rechnung im Anhang wurde versendet",
			"cancelSubscriptionTitle": "Monatsabo kündigen?",
			"cancelSubscriptionDescription": "Die automatische Verlängerung wird beendet. Ihr Zugriff auf das Paket bleibt bis {date} erhalten.",
			"subscriptionCancelledUntil": "Gekündigt. Zugriff bis {date}.",
			"subscriptionCancellationDeadline": "Kündigung bis {date}, 23:59 Uhr (deutsche Zeit).",
			"subscriptionCancellationUnavailable": "Kündigung aktuell nicht möglich. Bitte Zahlungsstatus aktualisieren.",
			"appointmentCancellationByPhone": "Stornierung bitte telefonisch klären.",
			"subscriptionCancellationNotConfirmed": "Die Kündigung wurde nicht bestätigt.",
			"subscriptionCancellationConfirmed": "Das Monatsabo ist zum Laufzeitende gekündigt. Zugriff bis {date}.",
			"invoiceFilename": "Rechnung-{id}",
			"invoiceEmailNotConfirmed": "Der E-Mail-Versand wurde nicht bestätigt.",
			"invoiceEmailSent": "Die Rechnung wurde erneut an die hinterlegte E-Mail-Adresse des Rechnungsempfängers gesendet.",
			howToCancel: "Stornierungen bitte telefonisch beim Therapeuten anfragen."
		},
		routes: {
			dashboard: "Dashboard",
			users: "Benutzer",
			short_backoffice: "Backoffice",
			backoffice: "Backoffice",
			main: "Patientenanschicht",
			short_main: "Profil",
			products: "Produkte",
			retreat: "Retreat",
			psychotherapy: "Psychotherapie",
			coaching: "Coaching",
			supervision: "Supervision",
			settings: "Einstellungen",
			premises: "Standorte",
			diagnosis: "Diagnosen",
			services: "Leistungen",
			calendar: "Kalender",
			documents: "Dokumente",
			accounting: "Abrechnung",
			rooms: "Räume",
			productlist: "Produktkatalog",
			calendar__own: "Eigener",
			calendar__room: "Raumauslastung",
			calendar__monthly: "Monat",
			digitalProducts: "Digitale Inhalte",
			landingpageMain: "Start",
			landingpageShop: "Shop",
			landingpageContact: "Kontakt",
			landingpageAboutMe: "Über Mich",
			profile: "Stammdaten",
			user_products: "Verfügbare Produkte",
			purchases: "Meine Käufe",
			appointments: "Termine",
			overview: "Übersicht",
			retreats: "Retreats",
			own: "Eigener",
			monthly: "Monat",
			open: "Offene",
			bills: "Rechnungen",
			room: "Raum",
			productTypes: "Produkttypen",
			digitalBundle: "Medienpaket",
			digitalBundles: "Medienpakete",
		},
		constants: {
			'weekday_0': "Sonntag",
			'weekday_1': "Montag",
			'weekday_2': "Dienstag",
			'weekday_3': "Mittwoch",
			'weekday_4': "Donnerstag",
			'weekday_5': "Freitag",
			'weekday_6': "Samstag",
			'weekday_7': "Sonntag",
			'month_0': "Januar",
			'month_1': "Februar",
			'month_2': "März",
			'month_3': "April",
			'month_4': "Mai",
			'month_5': "Juni",
			'month_6': "Juli",
			'month_7': "August",
			'month_8': "September",
			'month_9': "Oktober",
			'month_10': "November",
			'month_11': "Dezember",
			'pending': 'Ausstehend',
			accountInactive: "Account inaktiv",
			patient: "Nutzer",
			therapist: "Therapeut",
			admin: "Administrator",
			employee: "Mitarbeiter",
			product_status_public: "Öffentlich",
			product_status_private: "Privat",
			payment_method_prepaid: "Vorkasse",
			payment_method_bill: "Rechnung",
			mediaTypes_products: "Kurse & Termine",
			mediaTypes_digitalmedias: "Digitale Pakete",
			locations_internal: "Vor Ort",
			locations_external: "Extern",
			locations_online: "Online",
			action_type_updated: "Update",
			action_type_created: "Neu",
			action_type_info: "Info",
			timeslot_status_planned: "Findet Statt",
			timeslot_status_cancelled: "Abgebrochen",
			timeslot_status_denied_by_therapist: "Vom Therapeuten abgelehnt",
			timeslot_status_denied_by_patient: "Vom Patienten abgelehnt",
			billing_status_created: "Entwurf",
			billing_status_pending: "Ausstehend",
			billing_status_overdue: "Überfällig",
			billing_status_paid: "Bezahlt",
			userToRetreatStatus_pending: "Wartet auf Bestätigung",
			userToRetreatStatus_accepted: "Akzeptiert",
			userToRetreatStatus_denied: "Abgelehnt",
			userToRetreatStatus_cancelled: "Teilnahme abgebrochen",
			bill_unit_hour: "Stunden",
			bill_unit_unit: "Stück",			
			subscription: "Monatsabo",
			one_time: "Einmalzahlung",
			monthly: "Monatlich"
		},
		landing: {
			myServices: "Meine Angebote",
			myServicesText: "In einer vertrauensvollen Atmosphäre biete ich Dir das Folgende",
			myServicesShopText: "Buchen Sie Kurse und Termine oder erwerben Sie digitale Inhalte",
			wayfinder: "Rüdiger Keilberg über Wegbegleiter",
			"wayfinderText": "Wie geht es dir auf deinem Weg? Geht es dir gut? Fühlt sich dein Weg gut und richtig an?\n\nManchmal wünschen wir uns Veränderung, ohne schon zu wissen, wie der nächste Schritt aussehen kann. Vielleicht kreisen Deine Gedanken um dieselben Fragen, oder Du spürst, dass etwas in Deinem Leben nicht mehr zu Dir passt. Du musst darauf nicht sofort eine Antwort haben.\n\nFür mich bedeutet Wegbegleitung, Dir auf Augenhöhe zu begegnen und gemeinsam mit Dir hinzuschauen: Was beschäftigt Dich? Was ist Dir wichtig? Und welche Möglichkeiten möchtest Du für Dich entdecken? Dabei darf Dein eigener Weg im Mittelpunkt stehen – mit Deinen Fragen, Deinen Grenzen und in Deinem Tempo.",
			"videoUnsupported": "Dein Browser unterstützt das Video-Tag nicht.",
			aboutMe: "Über mich",
			aboutMeText: "Schon seit meiner Kindheit habe ich mich für menschliches Verhalten interessiert. Dieses Interesse hat mich auch nicht verlassen, als ich, beruflich erfolgreich, an meine Grenzen stieß. Ich nahm eine Auszeit und horchte in mein Inneres. Nach einer sehr intensiven Auseinandersetzung mit meinen Grenzen und mir selbst merkte ich, dass diese Grenzen nur in meiner Vorstellung existieren.<br>Meine tiefe Überzeugung ist seither, dass all unsere Möglichkeiten in uns selbst schon da sind. Es braucht “nur” den richtigen Weg, um sie zu entfalten. Den Weg zu finden erfordert Selbstliebe. Anderen zu helfen diesen Weg zu finden wurde zu meiner Berufung und heute möchte ich mein Wissen teilen.",
			aboutMeButtonText: "Mehr über mich erfahren",
			contact: "Hast du noch Fragen?",
			contactText: "Nimm ganz unverbindlich Kontakt zu mir auf!",
			contactText2: "Jetzt Erstberatung vereinbaren",
			contactButtonText: "telefonisch und unverbindlich",
			card1: {
				title: "Staunend lernen",
				text: "Neben körperlichen Symptomen erkrankt häufig unsere Seele. Eine Gesprächspsychotherapie erweist sich hier häufig als hilfreich.",
				tags: "Retreats - Gruppentermine - Coaching",
				subtextNonMobile: ""
			},
			card2: {
				title: "Eigene Wege finden",
				text: "Menschen geraten häufig in die Situation, dass sie das Gefühl haben, Ihnen entgleitet die Kontrolle über Ihr eigenes Leben. Gemeinsam erarbeiten wir neue Handlungsspielräume.",
				tags: "Psychotherapie - Coaching",
				subtextNonMobile: ""
			},
			card3: {
				title: "Freiheit atmen",
				text: "Manchmal geraten wir in eine Lebenskrise, der wir uns machtlos ausgeliefert fühlen. Die Lösung liegt immer im Innen.",
				tags: "Breathwork",
				subtextNonMobile: ""
			},
			card4: {
				title: "Lebendig wachsen",
				text: "In meinen Gruppen-, Online-Seminaren und Workshops vermittle ich zu den jeweiligen Themengebieten Wissen, Selbst-Erkenntnisse und Selbsterfahrung.",
				tags: "",
				subtextNonMobile: "Innere Ruhe - Selbstsicherheit - Ein Sicherer Weg in deine Zukunft - Mentale Stärke - Unterstützung"
			},
		},
		titleScreens: {
			bannerText: "Rüdiger Keilberg<br>Heilpraktiker für Psychotherapie",
			privacy: "Datenschutzerklärung",
			imprint: "Impressum",
			agb: "Allgemeine Geschäftsbedingungen und Kundeninformationen",
			landing: "Deine Praxis für Psychotherapie, Supervision & &shy;Coaching",
			atmen: "PSYCHEDELIC &shy; BREATH®",
			breathwork: "BREATHWORK",
			lernen: "Staunend lernen",
			wegefinden: "Eigene Wege finden",
			shop: "Kurse und digitale Inhalte buchen",
			contact: "Kontakt",
		},
		atmen: {
			sec1: {
				title: "Ein tiefes Aufatmen für Deine innere Stärke",
				text: "Meine intensive Ausbildung zum zertifizierten <a href=\"https://www.psychedelicbreath.co\" target=\"_blank\" rel=\"noopener noreferrer\">PSYCHEDELIC BREATH®</a> Teacher habe ich direkt bei der Begründerin der Methode, <a href=\"https://www.evakaczor.co\" target=\"_blank\" rel=\"noopener noreferrer\">Eva Kaczor</a>, absolviert.<br><br>Nun öffne ich diesen Raum für Dich. Ich bin fest davon überzeugt, dass diese Praxis das Potenzial hat, auch Dein Leben positiv zu verändern, Blockaden zu lösen und neue Energie freizusetzen. Bist Du bereit für Deine eigene Reise?"
			},
			sec2: {
				title: "DAS KONZEPT",
				text: "PSYCHEDELIC BREATH® ist eine 75- bis 90-minütige dynamische Atempraxis, die eine fundierte Einführung in die neurobiologische Wirkung und die wissenschaftlichen Hintergründe der Methode beinhaltet. Elektronische Musik begleitet die Atempraxis und ist somit ein elementarer Bestandteil dieser Methode. <br><br>Fühl Dich von einem klaren Beat und die jeweilige Stimmung der Musik getragen und unterstützt. Diese unterstützt die sensorische und mentale Erfahrung der Praxis auf höchstem Niveau.",
			},
			sec3: {
				title: "DIE EFFEKTE & WIRKUNG",
				text: "<b>Veränderung deiner Gehirnfrequenzen:</b> Erreiche mühelos tiefere, meditative Zustände. <br><br><b>Erweiterte Bewusstseinszustände:</b> Erkunde neue, tiefgreifende Ebenen deines Bewusstseins auf sicherem und natürlichem Weg. <br><br><b>Erlebe transiente Hypofrontalität:</b> Durch eine temporäre Beruhigung des präfrontalen Cortex verstummt dein innerer Kritiker – das öffnet den Raum für eine deutlich höhere intuitive und kreative Kapazität.<br><br><b>Ganzheitliches Loslassen:</b> Löse mentale, emotionale und körperliche Blockaden sowie tiefsitzende Spannungen.<br><br><b>Nachhaltiger Stressabbau:</b> Befreie dein Nervensystem von oxidativem und emotionalem Stress.<br><br><b>Verbundenheit und Vertrauen:</b> Schaffe ein tiefes Gefühl der Verbundenheit zu dir selbst und echtes Vertrauen in dein Umfeld.",
			},
			sec4: {
				title: "Mehr Fokus, mehr Kreativität: PSYCHEDELIC BREATH® für Dein Business",
				text: "Bringe neue Energie in Dein Unternehmen. Als exklusives On-Site-Event lässt sich PSYCHEDELIC BREATH® maßgeschneidert in Deine Firmenkultur integrieren. Die Methode von Eva Kaczor verbindet alte Atempraxis mit moderner Neurowissenschaft und ist der perfekte Katalysator für Deine Firmenevents, Konferenzen oder Strategietagungen. <br><br><b>Die Einsatzbereiche im Überblick:</b><br><br><b>Team-Gefühl stärken:</b> Erlebe, wie tiefes Durchatmen Barrieren abbaut, das Vertrauen untereinander festigt und die Zusammenarbeit beflügelt.<br><br><b>Kreativität auf Knopfdruck:</b> Nutze die Atempraxis als Innovations-Boost vor Workshops, um starre Muster zu lösen und Raum für neue Ideen zu schaffen.<br><br><b>Klarheit im Founder Circle:</b> Schaffe eine Ebene für ehrlichen, fokussierten Austausch unter Gründern und Führungskräften.<br><br><b>Business-Mindfulness:</b> Biete Deinen Gästen auf Kongressen oder Offsites ein fundiertes Tool zur Regeneration und Neuausrichtung.</b>",
			},
			safety: {
				headline: "PSYCHEDELIC BREATH® ist kraftvoll, aber sicher – solange klare Grenzen beachtet werden.",
				title: "Kontraindikationen sind:",
				'grid-item1': "Schwangerschaft",
				'grid-item2': "Herz-Kreislauf-Erkrankungen",
				'grid-item3': "Unbehandelter Bluthochdruck",
				'grid-item4': "Vergangener Schlaganfall",
				'grid-item5': "Kürzlich erfolgte Operationen im Oberkörper- oder Gesichtsbereich",
				'grid-item6': "Epilepsie",
				'grid-item7': "Klinische Angststörung / Psychosen",
				'grid-item8': "Hoher Augeninnendruck (Glaukom) / Netzhautablösung",
				subline: "Solltest Du Fragen zu diesem Thema haben, nimm einfach Kontakt zu mir auf!",
			},
		},
		lernen: {
			sec1: {
				title: "Raus aus dem Hamsterrad, rein ins eigene Leben",
				text: "Viele Menschen kennen das Gefühl, in einem Hamsterrad gefangen zu sein. Sie funktionieren, handeln und leisten den ganzen Tag – doch am Ende bleibt die Erfüllung aus. Oft liegt das daran, dass wir uns unbewusst an den Maßstäben und Erwartungen anderer orientieren, statt unserem eigenen inneren Kompass zu folgen.<br><br><ul><li>Wie fühlt sich dein Alltag an? Startest du wach, voller Begeisterung und lebendig in den Tag? Oder fühlt sich mittlerweile alles nur noch müde, schwer und routiniert an?</li><br><li>Nutzt du dein wahres Potenzial? Kennst du deine tatsächlichen Stärken und spielst du sie im Leben voll aus? Oder verlierst du dich im Versuch, deine Schwächen zu bekämpfen und jemand zu sein, der du gar nicht bist?</li><br><br><li>Kennst du den „Flow“? Weißt du noch, wie es ist, ganz im Moment zu sein? Wenn die Zeit verfliegt und der innere Kritiker im Kopf endlich einmal Pause hat?</li></ul",
			},
			sec2: {
				title: "Findest du dich in deinem Leben wieder?",
				text: "Wenn du heute auf dein Leben blickst – was siehst du dann? Ist es genau das Leben, das du dir immer gewünscht hast, oder fühlt es sich insgeheim so an, als ob etwas Wesentliches fehlt?<br><br>Vielleicht hast du im Leben schon viel erreicht. Doch wenn du in Momenten der Ruhe darüber nachdenkst: Macht dich das, was du tust, wirklich von Herzen glücklich?",
				gohere: "Mehr zu diesem Thema findest du hier: ",
				theme: "Eigene Wege finden",
			},
			sec3: {
				title: "Mein Coaching-Angebot: Dein Weg zu dir selbst",
				text: "Wenn du spürst, dass es Zeit für eine Veränderung in deinem Leben ist, stehe ich dir als Coach partnerschaftlich und kompetent zur Seite. Gemeinsam arbeiten wir daran, dass du dein volles Potenzial entfaltest und ein Leben nach deinen eigenen Maßstäben gestaltest.<br><br>Im Coaching unterstütze ich dich dabei:<br><br><li>Deine Stärken zu erkennen: Wir legen deine echten Potenziale frei, damit du sie gezielt einsetzen kannst.</li><br><br><li>Konditionierungen abzulegen: Wir entlarven alte Verhaltens- und Denkmuster, die du im Laufe deines Lebens erlernt hast, die aber gar nicht zu dir gehören.</li><br><br><li>Eigene Maßstäbe zu entwickeln: Du gewinnst eine klare Richtung für dein Leben und lernst zu unterscheiden, welche Ziele für dich persönlich sinnvoll sind und welche nicht.</li><br><br><li>Die Sinnfrage zu beantworten: Wir ergründen das „Warum“ hinter deinem Handeln und finden heraus, was deinem Leben wirklich Sinn verleiht.</li>",
			},
			sec4: {
				title: "Blockaden lösen und Veränderung verstehen",
				text: "Veränderung ist ein Prozess. Ich helfe dir zu verstehen, wie dein Verstand arbeitet und wie innere Blockaden überhaupt entstehen. Viel wichtiger aber: Ich zeige dir wirksame Methoden, wie du diese Blockaden nachhaltig lösen und echte, spürbare Veränderung in dein Leben bringen kannst.<br><br>Lass uns beginnen<br><br>Du musst den Weg der Veränderung nicht alleine gehen. Wenn du bereit bist, die Antworten in dir zu entdecken, nimm einfach Kontakt zu mir auf.<br><br>In einem ersten Gespräch lernen wir uns kennen. Anschließend erarbeiten wir gemeinsam einen maßgeschneiderten Coaching-Plan, der exakt zu deiner Lebenssituation passt, und setzen diesen Schritt für Schritt um.<br><br>Ich freue mich darauf, dich ein Stück deines Weges zu begleiten.",
			},
		},
		wegefinden: {
			sec1: {
				title: "In der Psychotherapie geht es um die Seele",
				text: "Häufig existieren bereits körperliche Symptome, aber erkrankt ist unsere Seele, also unsere Psyche. Krankheitsbilder sind zum Beispiel:<br><br><li>Depressionen</li><br><li>Ängste und Angststörungen</li><br><li>Zwänge</li><br><li>Psychosomatische Erkrankungen</li><br><li>Somatoforme Störungen, d.h. körperliche Beschwerden, die keine erkennbare organische Ursache haben</li><br><br>Unsere Gefühle, körperlichen Empfindungen, das Denken und Handeln geraten aus dem Gleichgewicht, sodass das Meistern des Alltäglichen zur leidvollen Herausforderung wird.",
			},
			sec2: {
				title: "Durch Gespräche sich selbst & den eigenen Weg erkennen",
				text: "Durch folgende und weitere Techniken versetze ich Dich in die Lage den Heilungsprozess aktiv zu gestalten.<br><br><li>Gespräche zur Reflexion</li><br><li>Gefühlsklärungen</li><br><li>Beobachten von Gedankenmustern</li><br><li>Biographische Rückblicke</li><br><li>Raum für bisher Unausgesprochenes</li><br><li>Achtsamkeitsübungen in der Selbstwahrnehmung</li><br><li>Geführte Meditationen & Gedankenreisen</li><br><li>Entspannungstechniken</li>",
				chat: "Einzelgespräch",
				price: "98€ - pro Stunde",
			},
			sec3: {
				title: "Die Funktionen der Psyche",
				text: "Bei der ganzheitlichen Betrachtung des Menschen spielt die Psyche eine ganz besondere Rolle. Sie wird meist als System des menschlichen Wahrnehmens, Denkens und Fühlens beschrieben.<br>Damit ist die Gesamtheit der Gefühlsregungen und geistigen Vorgänge eines Menschen gemeint. Unsere Psyche ist unser Fenster zur Welt. Von ihrem Zustand hängen unsere Bewertungen, unser Denken, Fühlen und Handeln ab.<br><br>Ist sie gesund, ermöglicht sie uns eine unverzerrte Wahrnehmung dessen, was in unserem Inneren und im Außen passiert. Wir fühlen, denken und handeln im Einklang mit unseren Wünschen und Zielen. Ist unsere Psyche jedoch aus der Balance oder erkrankt, sind wir immer weniger dazu in der Lage, kraft unseres Handelns unsere Wünsche und Ziele zu erreichen.<br><br>Der überwiegende Teil unserer psychischen Aktivitäten läuft unbewusst ab. Nur ca. 5% sind uns gegenwärtig. Das ist der Grund, warum wir häufig Hilfe benötigen, um aus einem psychischen Ungleichgewicht wieder ins Gleichgewicht zu finden.",
			},
			sec4: {
				title: "Was ist Selbstliebe?",
				text: "Das Thema „Selbstliebe“ begegnet uns sehr häufig in psychologischen Ratgebern und Gesprächen. Was hat es damit auf sich?<br><br>Zuerst möchte ich betonen, dass Selbstliebe nicht mit Egoismus gleichzusetzen ist. Selbstliebe hat vielmehr etwas damit zu tun, wie wir über uns selbst denken und wie wir mit uns umgehen. Viel zu oft mangelt es uns an Selbstliebe. Das ist einfach zu erkennen. Beschimpfen wir uns, wenn uns etwas misslingt? Können wir uns Fehler, die wir im Leben einmal gemacht haben, einfach nicht verzeihen? Muten wir uns häufig viel zu viel zu? Ordnen wir unsere Bedürfnisse oft denen anderer unter? Mögen wir uns nicht im Spiegel anschauen? Fällt es uns schwer, uns einfach mal sein zu lassen?<br><br>Wenn Du eine oder mehrere dieser Fragen mit „Ja“ beantwortet hast, solltest Du Dich mit dem Thema Selbstliebe einmal näher beschäftigen. Sie ist der Schlüssel zu einem gesunden Gleichgewicht zwischen Dir und der Welt in allen Lebensbereichen.",
			},
		},
		breathwork: {
			sec1: {
				title: "Was ist Atmen?",
				text: "Hast du dich schon einmal bewusst mit deinem Atem beschäftigt? Rein wissenschaftlich betrachtet ist Atmen ein lebensnotwendiger Prozess – ein ständiger Gasaustausch, bei dem du Sauerstoff aufnimmst und Kohlendioxid wieder abgibst. Da dieser Vorgang meist ganz automatisch abläuft, ohne dass wir ihn bewusst steuern, entwickeln wir im Laufe der Zeit oft unbewusste Atemgewohnheiten. Dabei spielt es für unser Wohlbefinden eine große Rolle, ob wir durch die Nase oder den Mund atmen oder ob die Luft nur flach in die Brust oder tief in den Bauch fließt.<br><br>Dein Atem ist wie ein Spiegel deines Inneren: Er zeigt direkt an, wie du dich gerade fühlst. Wenn du gestresst oder gehetzt bist, atmest du in der Regel schneller und flacher; bist du hingegen tiefenentspannt, wird dein Atem automatisch langsamer. Das liegt an unserem autonomen Nervensystem. Während der Sympathikus uns Energie gibt und aktiviert, sorgt der Parasympathikus für Beruhigung und kann unser System sogar „resetten“.<br><br>Über die Atmung kannst du zudem gezielt deinen Vagusnerv aktivieren. Da dieser Nerv durch den gesamten Körper verläuft und viele wichtige Organe miteinander verbindet, hat dein Atem direkten Einfluss auf deine Organe, deine Gesundheit und dein gesamtes Fühlen.<br><br>Stell dir das Atmen wie das Prinzip von Ebbe und Flut vor: Es ist ein ständiges Nehmen und Geben, eine Expansion und Kontraktion. Es erinnert uns daran, dass das gesamte Leben aus Rhythmus besteht. Man kann nicht nur einatmen und man kann nicht nur ausatmen – beides bedingt einander.<br><br>Nimm dir einen kurzen Moment Zeit, während du das liest, und spüre nach: Wie fühlt sich dein Atem gerade an? Fließt er eher flach in die Brust oder tief in deinen Bauch?",
			},
			sec2: {
				title: "Was genau ist Breathwork?",
				text: "Wie der Name schon sagt, geht es hier um „Atemarbeit“. Im Grunde drehen wir den gewohnten Prozess einfach um: Wir holen den Atem aus der automatischen, unbewussten Ecke hervor und steuern ihn ganz bewusst.<br><br>Das ist ein kraftvolles Werkzeug, denn über deinen Atem kannst du wie mit einer Fernbedienung gezielt verschiedene Zustände in deinem Körper erzeugen:<br><br>Der Ruhemodus: Bestimmte Techniken aktivieren den Parasympathikus. Er wirkt beruhigend auf dich und kann dein gesamtes System bis auf die Nervenebene entspannen oder sogar „resetten“.<br><br>Der Energiemodus: Andere Techniken regen den Sympathikus an. Sie schenken dir frische Energie und rufen ganz spezifische, kraftvolle Zustände in deinem System hervor.<br><br><b>Eine alte Wissenschaft in modernem Gewand</b><br><br>Die Idee, den Atem als Schlüssel zum Inneren zu nutzen, ist keineswegs neu. Schon vor Jahrtausenden setzten Menschen Atemtechniken ein, um besondere Bewusstseinszustände zu erreichen – ob in den Klöstern Tibets oder im indischen Yoga durch die Wissenschaft des Pranayama.<br><br>Auf dieser langen Tradition bauen auch moderne Methoden auf, die du heute finden kannst, wie das „holotrope Atmen“, „Rebirthing“ oder das „Psychedelic Breathwork ©“.<br><br><b>Deine Einladung an dich selbst</b><br><br>Ich möchte dich herzlich einladen, dich auf diese Erfahrung einzulassen. Wenn wir gemeinsam Breathwork praktizieren, lernst du Schritt für Schritt, wie du selbst Einfluss auf dein Wohlbefinden, deine Gesundheit und deine Gefühle nehmen kannst.<br><br>Es geht darum, genau die Zustände in dir zu erschaffen, die dir guttun und die Veränderungen anzustoßen, die du dir für dein Leben wünschst.",
			},
		},
		aboutMe: {
			bannerText: "Rüdiger Keilberg",
			bannerTitle: "Über mich",
			aboutMeQuote: "Probleme kann man niemals mit derselben Denkweise lösen, durch die sie entstanden sind.",
			aboutMeQuoteAuthor: "Albert Einstein",
			meTitle: "Mein Werdegang",
			meText: "Ich bin 1969 in Duisburg geboren, aufgewachsen und war früh von der Frage „Was macht den Menschen aus?” inspiriert. Schon als Kind habe ich mich oft gefragt, warum sich die Menschen so verhalten, wie sie sich verhalten. Auch die Frage „Ist der Mensch von Grund auf gut?“ hat mich immer schon sehr beschäftigt. Diese Frage war der Anfang eines Weges, auf dem ich Einblicke in viele Lebensbereiche gewann und vielfältige Erfahrungen sammelte. Bis heute.<br>Das Berufsleben führte mich in verschiedene Führungspositionen, bis ich selbst an meine Grenzen stieß. So dachte ich. Es waren aber nur die Grenzen in meinem Kopf, die ich in einer Auszeit und intensiver Auseinandersetzung mit mir selbst überwinden lernte. Ich stieg wieder in meine Tätigkeit als Führungskraft ein und erkannte, dass ich mit meinem „neuen Bewusstsein“ die Menschen in meinem beruflichen und privaten Umfeld inspiriere. Da wusste ich, wo mein ureigenes Potential liegt.<br>Ich entschied mich für eine mehrjährige Ausbildung zum Heilpraktiker für Psychotherapie und legte meine Prüfung erfolgreich ab.<br><br>Nun habe ich mich entschieden ein neues Kapitel meines Wirkens aufzuschlagen. Ich habe mich von meiner Führungsarbeit in der Wirtschaft verabschiedet und konzentriere mich auf meine Arbeit mit meinen Klienten und Patienten. Dies erfüllt mich selbst mit so viel Freude und Frieden, sodass ich mich mit dieser Entscheidung sehr wohl fühle.",
			anthropologyTitle: "Mein Menschenbild",
			anthropologyText: "Ich glaube, dass jeder Mensch mit einem großen, ureigenen Potenzial geboren wird und eine maximale Motivation mitbringt, sich in seinem Leben zu entfalten. Das Leben bringt es aber mit sich, dass Hemmnisse diese Potentialentfaltung beeinträchtigen. Insbesondere in der Kindheit sind wir häufig Verletzungen und Glaubenssätzen anderer ausgesetzt, die sich so stark in unserem Denken, Fühlen und Handeln verankern, dass wir nur noch einen eingeschränkten Einfluss auf unsere eigene Entwicklung verspüren.<br>Dieser verloren gegangene Handlungsspielraum verhindert unsere Potentialentfaltung und macht uns manchmal sogar krank.<br>In jedem Menschen steckt aber die Kraft und Lösung, sich diesen Handlungsspielraum zurückzuerobern. Dazu braucht es häufig einen neutralen Menschen, der die notwendige Unterstützung bieten kann: einen Wegbegleiter.",
			functionTitle: "Die Funktionen der Psyche",
			functionText: "Bei der ganzheitlichen Betrachtung des Menschen spielt die Psyche eine ganz besondere Rolle. Sie wird meist als System des menschlichen Wahrnehmens, Denkens und Fühlens beschrieben. Damit ist die Gesamtheit der Gefühlsregungen und geistigen Vorgänge eines Menschen gemeint. Unsere Psyche ist unser Fenster zur Welt. Von ihrem Zustand hängen unsere Bewertungen, unser Denken, Fühlen und Handeln ab.<br>Ist sie gesund, ermöglicht sie uns eine unverzerrte Wahrnehmung dessen, was in unserem Inneren und im Außen passiert. Wir fühlen, denken und handeln im Einklang mit unseren Wünschen und Zielen. Ist unsere Psyche jedoch aus der Balance oder erkrankt, sind wir immer weniger dazu in der Lage, kraft unseres Handelns unsere Wünsche und Ziele zu erreichen.<br>Der überwiegende Teil unserer psychischen Aktivitäten läuft unbewusst ab. Nur ca. 5% sind uns gegenwärtig. Das ist der Grund, warum wir häufig Hilfe benötigen, um aus einem psychischen Ungleichgewicht wieder ins Gleichgewicht zu finden.",
			selfLoveTitle: "Was ist Selbstliebe?",
			selfLoveText: "Das Thema „Selbstliebe“ begegnet uns sehr häufig in psychologischen Ratgebern und Gesprächen. Was hat es damit auf sich?<br>Zuerst möchte ich betonen, dass Selbstliebe nicht mit Egoismus gleichzusetzen ist. Selbstliebe hat vielmehr etwas damit zu tun, wie wir über uns selbst denken und wie wir mit uns umgehen. Viel zu oft mangelt es uns an Selbstliebe. Das ist einfach zu erkennen. Beschimpfen wir uns, wenn uns etwas misslingt? Können wir uns Fehler, die wir im Leben einmal gemacht haben, einfach nicht verzeihen? Muten wir uns häufig viel zu viel zu? Ordnen wir unsere Bedürfnisse oft denen anderer unter? Mögen wir uns nicht im Spiegel anschauen? Fällt es uns schwer, uns einfach mal sein zu lassen?<br>Wenn Du eine oder mehrere dieser Fragen mit „Ja“ beantwortet hast, solltest Du Dich mit dem Thema Selbstliebe einmal näher beschäftigen. Sie ist der Schlüssel zu einem gesunden Gleichgewicht zwischen Dir und der Welt in allen Lebensbereichen.",
			questionTitle: "Die Frage “Wer bin ich wirklich?”",
			questionText: "Was für eine weitreichende Frage! Maximal komplex – und eigentlich ganz einfach. Um die richtige Antwort für Dich herauszufinden, bedarf es eines Weges der Selbsterfahrung und schließlich der Selbsterkenntnis. An dieser Stelle möchte ich nur einen Aspekt der Suche nach Dir selbst ansprechen:<br>Was passiert, wenn wir uns mit Besitz oder Haltungen und Konzepten identifizieren? Identifizieren wir uns beispielsweise mit einem teuren Sportwagen, dann fügen wir unserem „Ich“, in diesem Zusammenhang auch als „Ego“ bezeichnet, einen künstlichen Anteil hinzu, der mit unserem wahren Selbst nichts zu tun hat. Wir nehmen diesen Sportwagen jetzt als Teil von uns wahr. Wird ihm eine Schramme zugefügt, reagiert unser Körper so, als hätte man ihm selbst dies angetan und gerät unter Stress.<br>Die Wahrheit ist aber, dass unserem Körper und unserem wahren Selbst rein gar nichts passiert ist. Was wäre erst, wenn es etwa zum Verlust dieses Sportwagens käme?<br>Ähnliches passiert, wenn wir uns zu sehr mit der eigenen Meinung oder der Meinung anderer identifizieren. Das kann dazu führen, dass wir uns persönlich angegriffen fühlen, sobald jemand eine unterschiedliche Haltung vertritt. Seien wir also achtsam mit unseren Identifikationen.",
			confidentialityTitle: "Schweigepflicht",
			confidentialityText: "Ich unterliege der Schweigepflicht nach BGB.<br>In der Berufsordnung für Heilpraktiker (BOH) steht in Artikel 3 Abs. 1: „Heilpraktiker sind verpflichtet über alles Schweigen zu bewahren, was ihnen bei der Ausübung ihres Berufes anvertraut oder zugänglich gemacht wird. Im Gegensatz zur ärztlichen Schweigepflicht haben Heilpraktiker kein Zeugnisverweigerungsrecht.“<br>Das heißt, ich behandele die Informationen, die Sie mir geben, mit äußerster Diskretion und Verschwiegenheit. Eine Entbindung von der Schweigepflicht, z.B. gegenüber Krankenkassen, Ärzten oder dem Ehepartner, ist ausdrücklich nur nach Absprache mit Ihnen gestattet",
		},
		contact: {
			bannerTitle: "Kontakt",
			bannerText: "Ich freue mich auf Deine Anfrage und antworte Dir umgehend!",
			hintTitle: "Hinweis",
			hintText: "Gesetzliche Krankenkassen übernehmen keine Kosten für Heilpraktiker-Leistungen. <br>Daher erfolgt die Abrechnung direkt mit Selbstzahlern.<br>Einige private Kranken- und Zusatzversicherungen erstatten jedoch diese Leistungen ganz oder teilweise.<br>Für Rückfragen stehe ich Ihnen gerne zur Verfügung.",
		},
		purchases: {
			mySales: "Meine Käufe",
			myCourses: "Gebuchte Kurse",
			courseName: "Name",
			courseText: "Beschreibung",
			myDigitalContent: "Digitale Inhalte",
			shopLink: "Im Shop können Sie digitale Inhalte erwerben.",
			lookAt: "ansehen",
		},
		errorCodes: {
			"400": "400: Die Anfrage ist ungültig oder fehlerhaft.",
			"401": "401: Sie sind nicht autorisiert, auf diese Ressource zuzugreifen.",
			"402": "402: Für diese Anfrage ist eine Zahlung erforderlich.",
			"403": "403: Sie sind nicht berechtigt diese Aktion durchzuführen",
			"404": "404: Die angeforderte Ressource wurde nicht gefunden.",
			"405": "405: Die verwendete Methode ist für diese Ressource nicht erlaubt.",
			"406": "406: Die angeforderte Ressource ist im gewünschten Format nicht verfügbar.",
			"407": "407: Eine Proxy-Authentifizierung ist erforderlich.",
			"408": "408: Die Anfrage hat zu lange gedauert und wurde abgebrochen.",
			"409": "409: Es liegt ein Konflikt mit dem aktuellen Status der Ressource vor.",
			"410": "410: Diese Ressource ist dauerhaft nicht mehr verfügbar.",
			"411": "411: Für die Anfrage ist die Angabe der Länge erforderlich.",
			"412": "412: Eine Vorbedingung der Anfrage ist fehlgeschlagen.",
			"413": "413: Die gesendeten Daten sind zu groß.",
			"414": "414: Die angeforderte URL ist zu lang.",
			"415": "415: Der Medientyp wird vom Server nicht unterstützt.",
			"416": "416: Der angeforderte Bereich ist nicht verfügbar.",
			"417": "417: Die erwartete Serververarbeitung konnte nicht erfüllt werden.",
			"418": "418: Ich bin eine Teekanne (dieser Statuscode ist ein Scherz).",
			"421": "421: Die Anfrage wurde an den falschen Server weitergeleitet.",
			"422": "422: Die Anfrage enthält fehlerhafte Daten und kann nicht verarbeitet werden.",
			"423": "423: Die Ressource ist gesperrt.",
			"424": "424: Ein Nutzer mit dieser E-Mail existiert bereits",
			"425": "425: Die Anfrage ist zu früh eingegangen und wird nicht verarbeitet.",
			"426": "426: Ein Upgrade des Protokolls ist erforderlich, um fortzufahren.",
			"428": "428: Für diese Anfrage ist eine Vorbedingung erforderlich.",
			"429": "429: Zu viele Anfragen wurden in kurzer Zeit gestellt.",
			"431": "431: Die Header-Felder der Anfrage sind zu groß.",
			"451": "451: Diese Ressource ist aus rechtlichen Gründen nicht verfügbar.",
			"500": "500: Auf dem Server ist ein interner Fehler aufgetreten.",
			"501": "501: Die Funktion ist nicht implementiert.",
			"502": "502: Das Gateway hat eine ungültige Antwort erhalten.",
			"503": "503: Der Dienst ist momentan nicht verfügbar.",
			"504": "504: Das Gateway hat innerhalb der Zeit keine Antwort erhalten.",
			"505": "505: Die HTTP-Version wird nicht unterstützt.",
			"506": "506: Es ist ein Variant-Negotiation-Fehler aufgetreten.",
			"507": "507: Auf dem Server ist nicht genügend Speicherplatz verfügbar.",
			"508": "508: Eine Endlosschleife wurde erkannt.",
			"510": "510: Für diese Anfrage sind weitere Erweiterungen erforderlich.",
			"511": "511: Für den Netzwerkzugriff ist eine Authentifizierung erforderlich."
		},
		diagnosisNotice: {
			intro: "Einen Überblick über ausgewählte psychische Diagnosen findest Du in unserer",
			link: "Diagnoseübersicht.",
			disclaimer: "Die Informationen dienen ausschließlich der allgemeinen Orientierung. Sie sind keine individuelle Beratung, ermöglichen keine Selbstdiagnose und ersetzen keine ärztliche oder psychotherapeutische Untersuchung, Diagnose oder Behandlung. Sie enthalten keine auf Deine persönliche Situation abgestimmten Therapieempfehlungen. Aus der Darstellung einer Diagnose lässt sich nicht ableiten, dass eine entsprechende Behandlung in meiner Praxis angeboten wird. Trotz sorgfältiger Zusammenstellung können Vollständigkeit, Richtigkeit und Aktualität der Inhalte nicht garantiert werden. Bei Beschwerden oder Fragen zu einer möglichen Behandlung wende Dich bitte an eine entsprechend qualifizierte Fachperson."
		},
	},

};
